interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  const baseClass =
    "flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-2 text-sm transition-colors";

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${baseClass} ${
          current === 1
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
        }`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`${baseClass} ${
            page === current
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${baseClass} ${
          current === total
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}